module.exports = __webpack_public_path__ + "img/bgimg2.5cbcb36c.png";